import { brandSemantic } from '../config/brand';

export const INQUIRY_STATUSES = [
  'New Inquiry',
  'Sent to Procurement',
];

export const INQUIRY_STATUS_TONES = {
  'New Inquiry': { color: brandSemantic.info, background: brandSemantic.infoSoft, border: brandSemantic.infoBorder },
  'Sent to Procurement': { color: brandSemantic.warning, background: brandSemantic.warningSoft, border: brandSemantic.warningBorder },
};

export const QUOTE_STATUSES = [
  'Ready for Procurement',
  'Quotation in Process',
  'Ready for Sales Quote',
  'Sent to Sales Quote',
];

export const QUOTE_STATUS_TONES = {
  'Ready for Procurement': { color: brandSemantic.info, background: brandSemantic.infoSoft, border: brandSemantic.infoBorder },
  'Quotation in Process': { color: brandSemantic.warning, background: brandSemantic.warningSoft, border: brandSemantic.warningBorder },
  'Ready for Sales Quote': { color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
  'Sent to Sales Quote': { color: brandSemantic.textSecondary, background: brandSemantic.primarySoft, border: brandSemantic.primaryMuted },
};

export const OFFER_STATUSES = [
  'New Sales Quote',
  'Sent to the Customer',
  'Customer Accepted',
  'Order Created',
  'Sales Quote Canceled',
];

export const OFFER_STATUS_TONES = {
  'New Sales Quote': { color: brandSemantic.textSecondary, background: brandSemantic.primarySoft, border: brandSemantic.primaryMuted },
  'Sent to the Customer': { color: brandSemantic.info, background: brandSemantic.infoSoft, border: brandSemantic.infoBorder },
  'Customer Accepted': { color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
  'Order Created': { color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
  'Sales Quote Canceled': { color: brandSemantic.error, background: brandSemantic.errorSoft, border: brandSemantic.errorBorder },
};

export const ORDER_STATUSES = [
  'New Order',
  'Sent to the Implementation',
  'Waiting for Delivery',
  'Delivered',
  'Accepted by Customer',
  'Order Canceled',
];

export const ORDER_STATUS_TONES = {
  'New Order': { color: brandSemantic.textSecondary, background: brandSemantic.primarySoft, border: brandSemantic.primaryMuted },
  'Sent to the Implementation': { color: brandSemantic.warning, background: brandSemantic.warningSoft, border: brandSemantic.warningBorder },
  'Waiting for Delivery': { color: brandSemantic.info, background: brandSemantic.infoSoft, border: brandSemantic.infoBorder },
  Delivered: { color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
  'Accepted by Customer': { color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
  'Order Canceled': { color: brandSemantic.error, background: brandSemantic.errorSoft, border: brandSemantic.errorBorder },
};

// An Order's mere existence (in any non-canceled status) implies the underlying
// Offer was already accepted by the customer — used to flag a Lead as a Customer.
export const CONFIRMED_OFFER_STATUSES = [
  'Customer Accepted',
  'Order Created',
  'New Order',
  'Sent to the Implementation',
  'Waiting for Delivery',
  'Delivered',
  'Accepted by Customer',
];

export const CATEGORY_TONES = {
  Customer: { label: 'Customer', color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
  'Lead/Prospect': { label: 'Prospect', color: brandSemantic.info, background: brandSemantic.infoSoft, border: brandSemantic.infoBorder },
};

export const TYPE_TONES = {
  Order: { color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
  Offer: { color: brandSemantic.info, background: brandSemantic.infoSoft, border: brandSemantic.infoBorder },
  Quote: { color: brandSemantic.textSecondary, background: brandSemantic.primarySoft, border: brandSemantic.primaryMuted },
  Inquiry: { color: brandSemantic.warning, background: brandSemantic.warningSoft, border: brandSemantic.warningBorder },
};

export const DEFAULT_TONE = {
  color: brandSemantic.textSecondary,
  background: brandSemantic.primarySoft,
  border: brandSemantic.primaryMuted,
};

export const getInquiryStatusTone = (status) => INQUIRY_STATUS_TONES[status] || DEFAULT_TONE;
export const getQuoteStatusTone = (status) => QUOTE_STATUS_TONES[status] || DEFAULT_TONE;
export const getOfferStatusTone = (status) => OFFER_STATUS_TONES[status] || DEFAULT_TONE;
export const getOrderStatusTone = (status) => ORDER_STATUS_TONES[status] || DEFAULT_TONE;

export const PRIORITY_TONES = {
  High: { color: brandSemantic.error, background: brandSemantic.errorSoft, border: brandSemantic.errorBorder },
  Medium: { color: brandSemantic.warning, background: brandSemantic.warningSoft, border: brandSemantic.warningBorder },
  Low: { color: brandSemantic.success, background: brandSemantic.successSoft, border: brandSemantic.successBorder },
};
